// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1W7Sw","cardHeader":"styles_cardHeader__3khZC"};